<script>
export default {
  name: "TheStudentScholarshipHeaderCard",

  props: {
    nameFaculty: String
  }
}
</script>

<template>
  <v-card
    flat
    class="rounded-xl d-flex justify-center align-center"
    outlined
  >
    <v-card-title class="text-center title-wrap">
      Конкурс студентов {{nameFaculty}} на повышенную государственную академическую стипендию (ПГАС)
    </v-card-title>
  </v-card>
</template>

<style scoped>
.title-wrap {
  word-break: keep-all;
}
</style>